
import { IErrorStore } from "../../../error/types";

import type {
  TDirectSalesCatDetailsViewState,
  TFieldKey,
  TDirectSalesViewState,
} from "@./suf-store";
import type { IBaseStoreState } from "../../shared/baseStore.types";

import type { DirectSalesFlowSlug } from "./constants";

export enum TargetUser {
  CUSTOMER = "CUSTOMER",
  BRAND_AMBASSADOR = "BRAND_AMBASSADOR",
}

export interface IDirectSalesSignupFlowStore extends IBaseStoreState {
  viewState: TDirectSalesViewState;
  updateViewState(
    view: string,
    params: Partial<TDirectSalesViewState[keyof TDirectSalesViewState]> | Partial<TDirectSalesCatDetailsViewState>,
    catId?: string,
  ): void;
  sufQuizVersion: number;
  resetSignupFlow(): void;
  cardReaderId: string;
  setCardReaderId(id: string): void;
  targetUser: TargetUser
  setTargetUser(target: TargetUser): void;
}

export type IDirectSalesSignupFlowErrorStore = IErrorStore<TFieldKey, DirectSalesFlowSlug>;
